export default __webpack_public_path__ + "img/send-email-inverse.668b2775.svg";